<template>
  <div>
    <label
      v-if="label"
      :for="name"
      class="mb-1 block text-xs font-medium text-background-fg/70"
    >
      {{ label }}
    </label>
    <BaseTextInput
      :model-value="inputValue"
      :placeholder="placeholder"
      :type="type"
      :name="name"
      :has-error="hasError"
      :disabled="disabled"
      @blur="handleBlur"
      @[changeEvent]="handleChange"
    />
    <template v-if="hasError">
      <p class="mt-1 text-xs font-medium text-error">
        {{ errorMessage }}
      </p>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate"

const props = defineProps<{
  name: string
  type?: string
  label?: string
  placeholder?: string
  disabled?: boolean
  updateOnInput?: boolean
}>()

const name = toRef(props, "name")

const {
  value: inputValue,
  errorMessage,
  handleBlur,
  handleChange,
  meta,
} = useField<string | undefined>(name)

const hasError = computed(
  () => !!errorMessage.value && meta.touched
)

const changeEvent = computed(() =>
  props.updateOnInput ? "input" : "change"
)
</script>
